import {
  faFloppyDisk,
  faCircleXmark,
  faFilter,
  faNoteSticky,
  faCircleInfo,
  faCirclePlus,
  faBuildingCircleXmark,
  faCircleQuestion,
  faPenToSquare,
  faFilterCircleXmark,
  faCaretUp,
  faCaretDown,
  faUpRightFromSquare,
  faTimes,
  faDownload,
  faTrash,
  faGripVertical,
  faList,
  faBuildingFlag,
  faBars,
  faArrowsUpDownLeftRight,
  faX,
  faLocationDot,
  faSignal,
  faSackDollar,
  faMapLocationDot,
  faGear,
  faArrowRightLong,
} from "@fortawesome/free-solid-svg-icons";

export const icons = {
  save: {
    icon: faFloppyDisk,
    tooltip: "Save Changes",
    iconColor: "#198754",
    disabledColor: "#808080",
    size: "1.2rem",
  },
  discard: {
    icon: faCircleXmark,
    tooltip: "Discard Changes",
    iconColor: "#E02827",
    disabledColor: "#808080",
    size: "1.2rem",
    popupMessage: "Discard changes",
  },
  filter: {
    icon: faFilter,
    tooltip: "Filter",
    iconColor: "#1FA185",
    disabledColor: "#808080",
    backgroundColor: "transparent",
  },
  removeFilter: {
    icon: faFilterCircleXmark,
    tooltip: "Filter",
    iconColor: "#1FA185",
    disabledColor: "#808080",
    backgroundColor: "transparent",
  },
  delete: {
    icon: faTrash,
    tooltip: "Delete",
    iconColor: "#E02827",
    disabledColor: "#808080",
    popupMessage: "Confirm Deletion",
  },
  info: {
    icon: faCircleInfo,
    tooltip: "More Information",
    iconColor: "#0000FF",
    disabledColor: "#808080",
    disabledTooltip: "No info available",
  },
  question: {
    icon: faCircleQuestion,
    tooltip: "Help",
    iconColor: "#FFFFFF",
    disabledColor: "#808080",
    disabledTooltip: "No help available",
  },
  note: {
    icon: faNoteSticky,
    tooltip: "Notes",
    iconColor: "#CA8A04",
    disabledColor: "#808080",
  },
  add: {
    icon: faCirclePlus,
    tooltip: "Add",
    iconColor: "#198754",
    disabledColor: "#808080",
  },
  edit: {
    icon: faPenToSquare,
    tooltip: "Edit",
    iconColor: "#198754",
    disabledColor: "#808080",
  },
  emptyStructure: {
    icon: faBuildingCircleXmark,
    tooltip: "Empty Structure",
    iconColor: "#1E3050",
    disabledColor: "#808080",
  },
  caretUp: {
    icon: faCaretUp,
    tooltip: "Sort Ascending",
    iconColor: "#FFFFFF",
    backgroundColor: "transparent",
  },
  caretDown: {
    icon: faCaretDown,
    tooltip: "Sort Descending",
    iconColor: "#FFFFFF",
    backgroundColor: "transparent",
  },
  open: {
    icon: faUpRightFromSquare,
    tooltip: "Open",
    iconColor: "#007bff",
    disabledColor: "#808080",
  },
  close: {
    icon: faTimes,
    tooltip: "Close",
    iconColor: "#000000",
    disabledColor: "#808080",
  },
  export: {
    icon: faDownload,
    tooltip: "Export",
    iconColor: "#0D6EFD",
    disabledColor: "#808080",
  },
  list: {
    icon: faList,
    tooltip: "Switch To List View",
    iconColor: "#0071cd",
    disabledColor: "#808080",
  },
  grid: {
    icon: faGripVertical,
    tooltip: "Switch To Grid View",
    iconColor: "#0071cd",
    disabledColor: "#808080",
  },
  buildingFlag: {
    icon: faBuildingFlag,
    tooltip: "Add Temp Structure",
    iconColor: "#ffa500",
    disabledColor: "#808080",
  },
  moveBars: {
    icon: faBars,
    iconColor: "white",
    disabledColor: "#808080",
  },
  moveArrows: {
    icon: faArrowsUpDownLeftRight,
    iconColor: "white",
    disabledColor: "#808080",
  },
  remove: {
    icon: faX,
    iconColor: "red",
    disabledColor: "#808080",
  },
  location: {
    icon: faLocationDot,
    tooltip: "More Info",
    iconColor: "#0000ff",
    disabledColor: "#808080",
  },
  bandwidth: {
    icon: faSignal,
    tooltip: "Total Bandwith",
    iconColor: "",
    disabledColor: "#808080",
  },
  cost: {
    icon: faSackDollar,
    tooltip: "Total Cost",
    iconColor: "#12542F",
    disabledColor: "#808080",
  },
  siteMap: {
    icon: faMapLocationDot,
    tooltip: "Site Map",
    iconColor: "#059411ff",
    disabledColor: "#808080",
  },
  admin: {
    icon: faGear,
    tooltip: "Admin",
    iconColor: "#0D6EFD",
    disabledColor: "#808080",
  },
  moveToArrow: {
    icon: faArrowRightLong,
    tooltip: "Move To",
    iconColor: "#6c757d",
    disabledColor: "#808080",
    size: "2rem",
    backgroundColor: "transparent",
  },
};
